module.exports = __webpack_public_path__ + "static/img/picture6.4f5261bc.png";